import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import DailogComponent from "../../../forms/dailog-component";
import { t } from "i18next";
import AppButton from "../../../forms/button";

export default function SessionTimeOutDailog({
  open,
  onClose,
  remainingSeconds = 150,
  onStaySignedIn,
  onSignOut,
}) {
  const minutes = Math.floor(remainingSeconds / 60);
  const title = t("dialogs.sessionTimeout.title");
  const signOutText = t("dialogs.sessionTimeout.signOut");
  const staySignedInText = t("dialogs.sessionTimeout.staySignedIn");
  const descriptionLine1 = t("dialogs.sessionTimeout.descriptionLine1");
  const descriptionLine2 =
    t("dialogs.sessionTimeout.descriptionLine2.line1") + " ";
  const descriptionLine2Line2 = t(
    "dialogs.sessionTimeout.descriptionLine2.line2",
  );
  const descriptionLine2Line3 = t(
    "dialogs.sessionTimeout.descriptionLine2.line3",
  );
  const descriptionLine3 = t("dialogs.sessionTimeout.descriptionLine3");

  const actions = (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        width: "100%",
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        <AppButton
          onClick={onSignOut}
          variant="contained"
          text={signOutText}
          className="text-brandDark bg-lightButtonColor text-base gap-0 !mr-0 px-4 py-5 rounded-lg"
        />
      </Box>

      <Box sx={{ flex: 2 }}>
        <AppButton
          onClick={onStaySignedIn}
          variant="contained"
          fullWidth
          text={staySignedInText}
          className="text-lightButtonColor text-base gap-0 !mr-0 px-4 py-5 rounded-lg "
        />
      </Box>
    </Box>
  );

  return (
    <DailogComponent
      open={open}
      onClose={onClose}
      title={title}
      actions={actions}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <Typography className="text-xl">
          {descriptionLine1}
          <strong>{minutes} minutes</strong>
        </Typography>

        <Typography className="text-xl">
          {descriptionLine2}
          <strong>{descriptionLine2Line2}</strong>
          {descriptionLine2Line3}
        </Typography>

        <Typography className="text-xl">{descriptionLine3}</Typography>
      </Box>
    </DailogComponent>
  );
}

SessionTimeOutDailog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  remainingSeconds: PropTypes.number,
  onStaySignedIn: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
};
